module.exports = Roo.Badge;